const LOOPBACK_HOSTS = new Set(['127.0.0.1', 'localhost', '::1']);

export const normalizeAssetUrl = (inputUrl) => {
	if (!inputUrl || typeof inputUrl !== 'string') {
		return inputUrl;
	}

	if (typeof window === 'undefined') {
		return inputUrl;
	}

	try {
		const parsed = new URL(inputUrl, window.location.origin);
		const currentHost = window.location.hostname;

		// In local development, route loopback-hosted assets through dev-server proxy
		// so they work from LAN hostnames and https dev pages.
		if (process.env.NODE_ENV === 'development' && LOOPBACK_HOSTS.has(parsed.hostname)) {
			return `${parsed.pathname}${parsed.search}${parsed.hash}`;
		}

		// Prevent mixed-content issues for same-host http assets when frontend is on https.
		if (window.location.protocol === 'https:' && parsed.protocol === 'http:' && parsed.hostname === currentHost) {
			return `${parsed.pathname}${parsed.search}${parsed.hash}`;
		}

		return parsed.toString();
	} catch (error) {
		return inputUrl;
	}
};

export const getFallbackUserImage = () => '/user.png';

export const resolveExternalBaseUrl = (rawBaseUrl) => {
	if (!rawBaseUrl || typeof rawBaseUrl !== 'string') {
		return `${window.location.origin}/`;
	}

	const trimmed = rawBaseUrl.trim();
	if (trimmed.startsWith('http://') || trimmed.startsWith('https://')) {
		return trimmed.endsWith('/') ? trimmed : `${trimmed}/`;
	}

	return `${window.location.origin}/`;
};
